// extracted by mini-css-extract-plugin
var _1 = "EmailPrinterNotificationActions-moduleaction__GYJ2P NotificationInline-modulelink__qUi1a";
var _2 = "EmailPrinterNotificationActions-modulecontainer__dxvmu";
var _3 = "EmailPrinterNotificationActions-moduleseparator__yZXWJ";
export { _1 as "action", _2 as "container", _3 as "separator" }
